export default () => {
    const searchPanel = document.querySelector('.search-window');
    const filters = searchPanel.querySelectorAll('.search-filters__filter');
    const form = searchPanel.querySelector('.js-search-form');
    const input = searchPanel.querySelector('.search-window__input');
    const resultsArea = searchPanel.querySelector('.search-window__results');
    const errorArea = searchPanel.querySelector('.search-window__error');
    let latestTimestamp;
    let typeTimeout;
    let analyticsTimeout;

    if (!form) {
        return;
    }

    const handleError = (message) => {
        searchPanel.dataset.status = 'error';
        errorArea.innerHTML = message;

        searchPanel.classList.remove('search-window--loading');
    };

    const handleResponse = (timestamp, message) => {
        // If dealing with an old search result
        if (parseInt(timestamp, 10) !== latestTimestamp) {
            return;
        }

        searchPanel.dataset.status = 'results';
        searchPanel.dataset.activeFilter = 'all';

        //resultsArea.innerHTML = JSON.parse(message);
        const results = JSON.parse(message);
        for (const [key, value] of Object.entries(results)) {
            const container = resultsArea.querySelector(`.search-window__result--${key} .search-window__result-list`);
            if (container) {
                container.innerHTML = value;
                const total = document.querySelector(`.search-filters__filter--${key} .search-filters__total`);
                if (total) {
                    total.innerHTML = container.children.length;
                }
            } else {
                console.warn(`Container for ${key} not found`);
            }
        }

        searchPanel.classList.remove('search-window--loading');
    };

    const sendData = () => {
        latestTimestamp = Date.now();

        // Format request data
        const data = new FormData(form);
        data.append('action', 'search');
        data.append('security', WP.nonce);
        data.append('timestamp', latestTimestamp);

        // Send the request
        let responseStatus;
        let message;

        fetch(WP.ajax, {
            method: 'POST',
            body: data,
        })
            .then((response) => {
                responseStatus = response.status;
                return response.json();
            })
            .then((response) => {
                switch (responseStatus) {
                    case 200:
                    case 201:
                    case 202:
                        message = response.data.message;
                        if (response.success) {
                            handleResponse(response.data.timestamp, message);
                        } else {
                            handleError(JSON.parse(message));
                        }
                        break;
                    default:
                        message = WP.translate.error;
                        handleError(message);
                        break;
                }
            })
            .catch(() => {
                message = WP.translate.error;
                handleError(message);
            });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        sendData();
    };

    const handleType = () => {
        searchPanel.classList.add('search-window--loading');

        clearTimeout(typeTimeout);
        typeTimeout = setTimeout(sendData, 300);

        clearTimeout(analyticsTimeout);
        analyticsTimeout = setTimeout(() => {
            const searchRequest = new CustomEvent('search-request', { detail: { query: input.value } });
            document.body.dispatchEvent(searchRequest);
        }, 1000);
    };

    input.addEventListener('keydown', handleType);
    form.addEventListener('submit', handleSubmit);

    const handleFilter = (e) => {
        searchPanel.dataset.activeFilter = e.currentTarget.dataset.filterName;
    };

    filters.forEach((element) => {
        element.addEventListener('click', handleFilter);
    });
};
